<template>
    <div>
        <form class="divide-y divide-gray-200 lg:col-span-9"
              :action="action"
              method="POST"
              @submit="checkForm"
        >
            <slot></slot>
            <!-- Profile section -->
            <div class="pb-6 sm:pb-6 lg:pb-8">
                <div>
<!--                    <p class="mt-1 text-sm text-gray-500">-->
<!--                        Предоставление не достоверных данных приведет к блокировке.-->
<!--                    </p>-->

                </div>

                <div class="mt-6 flex flex-col lg:flex-row">

                    <!--Form-->
                    <div class="flex-grow space-y-6">

                        <div>
                            <label for="parts_groups" class="block text-sm font-medium text-gray-700 required">
                                Какая группа запчастей вам нужна?
                            </label>

                            <t-select id="parts_groups"
                                      name="parts_group_id"
                                      placeholder="Выберите группу запчастей"
                                      :options="parts_groups"
                                      v-model="data.parts_group_id"
                            />
                             <form-error :value="errors.parts_group_id"/>


                        </div>

                        <div>
                            <label for="condition" class="block text-sm font-medium text-gray-700">
                                Какое состояние запчасти вас интересует?
                            </label>

                            <t-radio-group id="condition"
                                           name="condition"
                                           :options="{ A: 'Любое', N: 'Только новое', U: 'Б/У' }"
                                            v-model="data.condition"
                            />


                        </div>
                        <div>
                            <label for="title" class="block text-sm font-medium text-gray-700 required">
                                Заголовок
                            </label>
                            <t-input
                                id="title"
                                name="title"
                                v-model="data.title"
                            />
                             <form-error :value="errors.title"/>
                        </div>

                        <div>
                            <label for="request" class="block text-sm font-medium text-gray-700 required">
                                Описание
                            </label>
                            <t-textarea
                                id="request"
                                name="request"
                                rows="5"
                                v-model="data.request"
                            />
                             <form-error :value="errors.request"/>
                        </div>


                    </div>

                </div>

            </div>


            <div class="mt-4 py-4 px-4 flex justify-center sm:px-6">
                <t-button type="submit">
                    Отправить
                </t-button>
            </div>

        </form>
    </div>
</template>

<script>
import FormError from "../elements/FormError";
export default {
    name: "PartsRequest",
    components: {FormError},
    props: {
        parts_groups: {
            type: Object,
            required: true
        },
        action: {
            type: String,
            required: true
        },
        // machinery_item_id: {
        //     type: Number,
        //     required: true
        // }

    },
    data: function () {
        return {
            'data': {
                condition: 'A'
            },
            'errors': {},
        }
    },
    methods: {
        checkForm: function (e) {
            let errors = new Array(0);
            this.errors = {};
            let required_fields = ['parts_group_id','title', 'request'];


             // Check required fields
                required_fields.forEach(field => {
                    if ( ! this.data[field]){
                        errors.push(field);
                    }
                });

                if (errors.length) {
                    errors.forEach(item => {
                        this.errors[item] = new Array(1);
                        this.errors[item][0] = "Поле обязательно для заполнения";
                    });
                }


                if ( ! _.isEmpty(this.errors)){
                    this.$swal ('Ошибки', 'Исправьте ошибки и повторите попытку', 'error');
                    e.preventDefault();
                    return false;
                }

                return true;
        }
    }
}
</script>

<style scoped>

</style>
